module.exports = __webpack_public_path__ + "img/Fabella_island_treasure.642766f4.png";